
import Vue from 'vue'

import tableEmpty from '@/components/tableEmpty'

Vue.component('table-empty', tableEmpty)
